import type { GridApi } from "ag-grid-community"
import type { RefObject } from "react"
import { useEffect } from "react"

export const useStopGridEditingOnOutsideMouseDown = <TData>(
  gridApiRef: RefObject<GridApi<TData> | undefined>,
  containerRef: RefObject<HTMLElement>
): void => {
  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      const api = gridApiRef.current
      const container = containerRef.current
      if (!api || api.isDestroyed() || !container) return
      if (container.contains(event.target as Node)) return

      api.stopEditing()
    }

    document.addEventListener("mousedown", handleMouseDown, true)

    return () => {
      document.removeEventListener("mousedown", handleMouseDown, true)
    }
  }, [gridApiRef, containerRef])
}
